import { render, staticRenderFns } from "./DecoratedMetaRel.vue?vue&type=template&id=5f2ddccf&scoped=true&"
import script from "./DecoratedMetaRel.vue?vue&type=script&lang=js&"
export * from "./DecoratedMetaRel.vue?vue&type=script&lang=js&"
import style0 from "./DecoratedMetaRel.vue?vue&type=style&index=0&id=5f2ddccf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2ddccf",
  null
  
)

export default component.exports